import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { ToNcpdpOptions } from "shared/helpers/LocationOptionHelpers";

export function useFetchUserLocations(selectedParentCompany) {
  const { oktaAuth } = useOktaAuth();
  const dataKey = "useFetchUserLocationsResultKey";

  async function getUserLocations() {
    if (!selectedParentCompany || !selectedParentCompany.value) {
      return [];
    }

    const oktaUser = await oktaAuth.getUser();

    const allLocationsParameters = {
      email: oktaUser.email,
      selectedItem: selectedParentCompany.value,
      organizationType: "ParentCompany",
      programSubscriptions: "RecMetric2.0",
    };

    const accessToken = await oktaAuth.getAccessToken();

    try {
      const allLocationsResponse = await axios.get(
        `api/UserProgram/GetUserLocationsDetails`,
        {
          params: allLocationsParameters,
          headers: {
            Authorization: `Bearer ${accessToken}`,
            RequestSrc: "/",
          },
        }
      );

      if (!allLocationsResponse.data) {
        return [];
      }

      return ToNcpdpOptions(allLocationsResponse.data);
    } catch (error) {
      throw new Error(error);
    }
  }

  return useQuery({
    queryKey: [dataKey, selectedParentCompany && selectedParentCompany.value],
    queryFn: async () => await getUserLocations(),
    enabled: !!(selectedParentCompany && selectedParentCompany.value),
  });
}
